var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscoftCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4693 20.764L3.19727 18.8752L3.21647 5.18558L13.4813 3.23438L13.4693 20.764Z",
    fill: "#2272BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42728 8.91406C7.13128 8.91406 6.08008 10.2893 6.08008 11.9837C6.08008 13.6781 7.13128 15.0533 8.42728 15.0533C9.72328 15.0533 10.7745 13.6781 10.7745 11.9837C10.7745 10.2869 9.72328 8.91406 8.42728 8.91406ZM8.43688 13.8797C7.78888 13.8797 7.26328 13.0325 7.26328 11.9885C7.26328 10.9445 7.78888 10.0973 8.43688 10.0973C9.08488 10.0973 9.61048 10.9445 9.61048 11.9885C9.61048 13.0325 9.08488 13.8797 8.43688 13.8797Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2178 6.88281V10.3004L15.485 11.0828L20.7818 7.57161C20.7818 7.57161 20.7746 7.53801 20.7554 7.48761C20.6306 7.13961 20.297 6.90921 19.9274 6.90681L14.2178 6.88281Z",
    fill: "#2272BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2466 11.819C14.2466 11.819 15.0914 12.7406 16.0394 12.2726C16.9754 11.807 20.8034 9.14062 20.8034 9.14062V15.5318C20.8034 16.0238 20.405 16.4222 19.913 16.4222H14.2178L14.2466 11.819Z",
    fill: "#2272BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscoftCalendar);
export default __webpack_public_path__ + "static/media/microscoft-calendar.e762fec676169360b94176342cc0799b.svg";
export { ForwardRef as ReactComponent };